import(/* webpackMode: "eager" */ "/vercel/path0/app/blog/_assets/components/HeaderBlog.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js")